/** Default post-OAuth destination for Wagamour app shell. */
export const DEFAULT_OAUTH_CALLBACK_URL = '/app-beta'

/** Safe relative callback path for NextAuth signIn (rejects open redirects). */
export function resolveOAuthCallbackUrl(raw?: string | null): string {
  const v = raw?.trim() || DEFAULT_OAUTH_CALLBACK_URL
  // Never use marketing homepage as post-OAuth destination (native or web).
  if (v === '/' || v === '') {
    return DEFAULT_OAUTH_CALLBACK_URL
  }
  if (!v.startsWith('/') || v.startsWith('//') || v.includes('http')) {
    return DEFAULT_OAUTH_CALLBACK_URL
  }
  return v
}
